export enum Variant {
  NoBorder = 'no_border',
  NoRound = 'no_round',
  NoShadow = 'no_shadow',
}
export type TVariant = Variant | 'no_border' | 'no_round' | 'no_shadow';
